module.exports = __webpack_public_path__ + "img/illu-intestine-lg.a9242a18.svg";